import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useSupercaseGet } from 'core/types'

import ModelLink from './ModelLink'

type SupercaseLinkProps = {
  supercaseId: string
}

const SupercaseLink: FC<SupercaseLinkProps> = ({ supercaseId }) => {
  const [_, { companyId: contextCompanyId }] = useQueryApi()
  const { data: supercase, isLoading } = useSupercaseGet({
    supercaseId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  // Use the companyId from the supercase object if available, otherwise from the context
  // contextCompanyId should be available from the URL params on the page /companies/:companyId/..
  const companyId = supercase?.companyId || contextCompanyId

  // Always generate the link if companyId is available (even during loading)
  // This ensures the link is correct
  const link = companyId
    ? `/companies/${companyId}/supercases/${supercaseId}`
    : undefined

  return (
    <ModelLink
      id={supercaseId}
      isLoading={isLoading}
      link={link}
      model={supercase}
    />
  )
}

export default SupercaseLink
